<div class="container mt-2" *ngIf="ShowDetails">
    <div class="row">

        <app-search-bar [showFilterBtn]="true" (onFilterBtnClick)="showFilter = true" [showPrimaryBtn]="false"
            (formValueChange)="handleFormValueChange($event)"></app-search-bar>
        <div class="details-container">
            <div class="details-data">
                <!-- <table class="details-table">
                    <thead>
                        <tr>
                            <th>Instituição</th>
                            <th>Curso</th>
                            <th>Data de início</th>
                            <th>Data fim</th>
                            <th>Estado</th>
                            <th>Acções</th>
                        </tr>
                    </thead>
                    <br>

                    <tbody>
                        <tr>
                            <td>Harvad</td>
                            <td>Engineer Technician</td>
                            <td>12/12/2025</td>
                            <td>12/12/2025</td>
                            <td>
                                <p>
                                    <span>Finalizado</span>
                                </p>
                            </td>
                            <td>
                                <button><i value="0" class="pi pi-ellipsis-v" (click)="ToggleDetails()"></i></button>

                                <div class="view-details" [ngClass]="{'active': ViewDetails === true}">
                                    ver detalhes
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
                <ng-container *ngIf="solicitacoesPagination.data?.length; else emptyTemplate">
                    <app-table [pagination]="solicitacoesPagination" [columns]="solicitacoesColumns"
                        [actions]="solicitacoesActions" (pageChange)="onSolicitacoesPageChange($event)"
                        (actionSelected)="onActionSelected($event)"></app-table>
                </ng-container>
                <ng-template #emptyTemplate>
                    <div class="no-data">
                        <app-data-void titulo="Nenhuma solicitação encontrada"
                            descricao="Clique em Solicitar Renovação para criar uma."></app-data-void>
                    </div>
                </ng-template>
            </div>

            <div class="btns-options mt-5">
                <!-- <button (click)="Return()">voltar</button> -->
                <!-- <button (click)="GotoRenoveBolse()">Renovar bolsa</button> -->
            </div>
        </div>

    </div>
</div>

<div class="container mt-2" *ngIf="ShowRenovar">
    <div class="row">

        <div class="details-container">

            <div class="details-info-bolsa">

                <div>
                    <h5>Instituição</h5>
                    <input type="text" disabled [value]="bolsaInstCursoRenovar?.instituicaoEnsinoNome">
                </div>

                <div>
                    <h5>Curso</h5>
                    <input type="text" disabled [value]="bolsaInstCursoRenovar?.cursoDesignacao">
                </div>

            </div>

            <div class="details-of-renove mt-3">
                <div>
                    <h5>Data de início</h5>
                    <article class="art-camp">
                        <input type="text" disabled value="12/12/2025">

                        <svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                            <g id="calendar-dots 1">
                                <path id="Vector"
                                    d="M14.125 3.25V3V2.375C14.125 2.27554 14.0855 2.18016 14.0152 2.10984C13.9448 2.03951 13.8495 2 13.75 2C13.6505 2 13.5552 2.03951 13.4848 2.10984C13.4145 2.18016 13.375 2.27554 13.375 2.375V3V3.25H13.125H6.875H6.625V3V2.375C6.625 2.27554 6.58549 2.18016 6.51516 2.10983M14.125 3.25L6.51516 2.10983M14.125 3.25H14.375H16.25C16.5152 3.25 16.7696 3.35536 16.9571 3.54289C17.1446 3.73043 17.25 3.98478 17.25 4.25V16.75C17.25 17.0152 17.1446 17.2696 16.9571 17.4571C16.7696 17.6446 16.5152 17.75 16.25 17.75H3.75C3.48478 17.75 3.23043 17.6446 3.04289 17.4571C2.85536 17.2696 2.75 17.0152 2.75 16.75V4.25C2.75 3.98478 2.85536 3.73043 3.04289 3.54289C3.23043 3.35536 3.48478 3.25 3.75 3.25H5.625H5.875V3V2.375C5.875 2.27554 5.91451 2.18016 5.98483 2.10984C6.05516 2.03951 6.15054 2 6.25 2C6.34946 2 6.44484 2.03951 6.51516 2.10983M14.125 3.25L6.69194 1.93306L6.51516 2.10983M5.875 4.25V4H5.625H3.75H3.5V4.25V6.75V7H3.75H16.25H16.5V6.75V4.25V4H16.25H14.375H14.125V4.25V4.875C14.125 4.97446 14.0855 5.06984 14.0152 5.14016C13.9448 5.21049 13.8495 5.25 13.75 5.25C13.6505 5.25 13.5552 5.21049 13.4848 5.14017C13.4145 5.06984 13.375 4.97446 13.375 4.875V4.25V4H13.125H6.875H6.625V4.25V4.875C6.625 4.97446 6.58549 5.06984 6.51517 5.14016C6.44484 5.21049 6.34946 5.25 6.25 5.25C6.15054 5.25 6.05516 5.21049 5.98484 5.14017C5.91451 5.06984 5.875 4.97446 5.875 4.875V4.25ZM16.25 17H16.5V16.75V8V7.75H16.25H3.75H3.5V8V16.75V17H3.75H16.25ZM10.6875 10.8125C10.6875 10.9485 10.6472 11.0814 10.5716 11.1945C10.4961 11.3075 10.3887 11.3956 10.2631 11.4477C10.1375 11.4997 9.99924 11.5133 9.86588 11.4868C9.73251 11.4603 9.61001 11.3948 9.51386 11.2986C9.41772 11.2025 9.35224 11.08 9.32571 10.9466C9.29918 10.8133 9.3128 10.675 9.36483 10.5494C9.41687 10.4238 9.50499 10.3164 9.61805 10.2409C9.7311 10.1653 9.86403 10.125 10 10.125C10.1823 10.125 10.3572 10.1974 10.4861 10.3264C10.6151 10.4553 10.6875 10.6302 10.6875 10.8125ZM14.125 10.8125C14.125 10.9485 14.0847 11.0814 14.0091 11.1945C13.9336 11.3075 13.8262 11.3956 13.7006 11.4477C13.575 11.4997 13.4367 11.5133 13.3034 11.4868C13.17 11.4603 13.0475 11.3948 12.9514 11.2986C12.8552 11.2025 12.7897 11.08 12.7632 10.9466C12.7367 10.8133 12.7503 10.675 12.8023 10.5494C12.8544 10.4238 12.9425 10.3164 13.0555 10.2409C13.1686 10.1653 13.3015 10.125 13.4375 10.125C13.6198 10.125 13.7947 10.1974 13.9236 10.3264C14.0526 10.4553 14.125 10.6302 14.125 10.8125ZM7.25 13.9375C7.25 14.0735 7.20968 14.2064 7.13414 14.3195C7.05859 14.4325 6.95122 14.5206 6.82559 14.5727C6.69997 14.6247 6.56174 14.6383 6.42838 14.6118C6.29501 14.5853 6.17251 14.5198 6.07636 14.4236C5.98022 14.3275 5.91474 14.205 5.88821 14.0716C5.86168 13.9383 5.8753 13.8 5.92733 13.6744C5.97937 13.5488 6.06749 13.4414 6.18055 13.3659C6.2936 13.2903 6.42653 13.25 6.5625 13.25C6.74484 13.25 6.9197 13.3224 7.04864 13.4514C7.17757 13.5803 7.25 13.7552 7.25 13.9375ZM10.6875 13.9375C10.6875 14.0735 10.6472 14.2064 10.5716 14.3195C10.4961 14.4325 10.3887 14.5206 10.2631 14.5727C10.1375 14.6247 9.99924 14.6383 9.86588 14.6118C9.73251 14.5853 9.61001 14.5198 9.51386 14.4236C9.41772 14.3275 9.35224 14.205 9.32571 14.0716C9.29918 13.9383 9.3128 13.8 9.36483 13.6744C9.41687 13.5488 9.50499 13.4414 9.61805 13.3659C9.7311 13.2903 9.86403 13.25 10 13.25C10.1823 13.25 10.3572 13.3224 10.4861 13.4514C10.6151 13.5803 10.6875 13.7552 10.6875 13.9375ZM14.125 13.9375C14.125 14.0735 14.0847 14.2064 14.0091 14.3195C13.9336 14.4325 13.8262 14.5206 13.7006 14.5727C13.575 14.6247 13.4367 14.6383 13.3034 14.6118C13.17 14.5853 13.0475 14.5198 12.9514 14.4236C12.8552 14.3275 12.7897 14.205 12.7632 14.0716C12.7367 13.9383 12.7503 13.8 12.8023 13.6744C12.8544 13.5488 12.9425 13.4414 13.0555 13.3659C13.1686 13.2903 13.3015 13.25 13.4375 13.25C13.6198 13.25 13.7947 13.3224 13.9236 13.4514C14.0526 13.5803 14.125 13.7552 14.125 13.9375Z"
                                    stroke-width="0.5" />
                            </g>
                        </svg>
                    </article>
                </div>

                <div>
                    <h5>Data fim</h5>
                    <article class="art-camp">
                        <input type="text" disabled value="12/12/2025">

                        <svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                            <g id="calendar-dots 1">
                                <path id="Vector"
                                    d="M14.125 3.25V3V2.375C14.125 2.27554 14.0855 2.18016 14.0152 2.10984C13.9448 2.03951 13.8495 2 13.75 2C13.6505 2 13.5552 2.03951 13.4848 2.10984C13.4145 2.18016 13.375 2.27554 13.375 2.375V3V3.25H13.125H6.875H6.625V3V2.375C6.625 2.27554 6.58549 2.18016 6.51516 2.10983M14.125 3.25L6.51516 2.10983M14.125 3.25H14.375H16.25C16.5152 3.25 16.7696 3.35536 16.9571 3.54289C17.1446 3.73043 17.25 3.98478 17.25 4.25V16.75C17.25 17.0152 17.1446 17.2696 16.9571 17.4571C16.7696 17.6446 16.5152 17.75 16.25 17.75H3.75C3.48478 17.75 3.23043 17.6446 3.04289 17.4571C2.85536 17.2696 2.75 17.0152 2.75 16.75V4.25C2.75 3.98478 2.85536 3.73043 3.04289 3.54289C3.23043 3.35536 3.48478 3.25 3.75 3.25H5.625H5.875V3V2.375C5.875 2.27554 5.91451 2.18016 5.98483 2.10984C6.05516 2.03951 6.15054 2 6.25 2C6.34946 2 6.44484 2.03951 6.51516 2.10983M14.125 3.25L6.69194 1.93306L6.51516 2.10983M5.875 4.25V4H5.625H3.75H3.5V4.25V6.75V7H3.75H16.25H16.5V6.75V4.25V4H16.25H14.375H14.125V4.25V4.875C14.125 4.97446 14.0855 5.06984 14.0152 5.14016C13.9448 5.21049 13.8495 5.25 13.75 5.25C13.6505 5.25 13.5552 5.21049 13.4848 5.14017C13.4145 5.06984 13.375 4.97446 13.375 4.875V4.25V4H13.125H6.875H6.625V4.25V4.875C6.625 4.97446 6.58549 5.06984 6.51517 5.14016C6.44484 5.21049 6.34946 5.25 6.25 5.25C6.15054 5.25 6.05516 5.21049 5.98484 5.14017C5.91451 5.06984 5.875 4.97446 5.875 4.875V4.25ZM16.25 17H16.5V16.75V8V7.75H16.25H3.75H3.5V8V16.75V17H3.75H16.25ZM10.6875 10.8125C10.6875 10.9485 10.6472 11.0814 10.5716 11.1945C10.4961 11.3075 10.3887 11.3956 10.2631 11.4477C10.1375 11.4997 9.99924 11.5133 9.86588 11.4868C9.73251 11.4603 9.61001 11.3948 9.51386 11.2986C9.41772 11.2025 9.35224 11.08 9.32571 10.9466C9.29918 10.8133 9.3128 10.675 9.36483 10.5494C9.41687 10.4238 9.50499 10.3164 9.61805 10.2409C9.7311 10.1653 9.86403 10.125 10 10.125C10.1823 10.125 10.3572 10.1974 10.4861 10.3264C10.6151 10.4553 10.6875 10.6302 10.6875 10.8125ZM14.125 10.8125C14.125 10.9485 14.0847 11.0814 14.0091 11.1945C13.9336 11.3075 13.8262 11.3956 13.7006 11.4477C13.575 11.4997 13.4367 11.5133 13.3034 11.4868C13.17 11.4603 13.0475 11.3948 12.9514 11.2986C12.8552 11.2025 12.7897 11.08 12.7632 10.9466C12.7367 10.8133 12.7503 10.675 12.8023 10.5494C12.8544 10.4238 12.9425 10.3164 13.0555 10.2409C13.1686 10.1653 13.3015 10.125 13.4375 10.125C13.6198 10.125 13.7947 10.1974 13.9236 10.3264C14.0526 10.4553 14.125 10.6302 14.125 10.8125ZM7.25 13.9375C7.25 14.0735 7.20968 14.2064 7.13414 14.3195C7.05859 14.4325 6.95122 14.5206 6.82559 14.5727C6.69997 14.6247 6.56174 14.6383 6.42838 14.6118C6.29501 14.5853 6.17251 14.5198 6.07636 14.4236C5.98022 14.3275 5.91474 14.205 5.88821 14.0716C5.86168 13.9383 5.8753 13.8 5.92733 13.6744C5.97937 13.5488 6.06749 13.4414 6.18055 13.3659C6.2936 13.2903 6.42653 13.25 6.5625 13.25C6.74484 13.25 6.9197 13.3224 7.04864 13.4514C7.17757 13.5803 7.25 13.7552 7.25 13.9375ZM10.6875 13.9375C10.6875 14.0735 10.6472 14.2064 10.5716 14.3195C10.4961 14.4325 10.3887 14.5206 10.2631 14.5727C10.1375 14.6247 9.99924 14.6383 9.86588 14.6118C9.73251 14.5853 9.61001 14.5198 9.51386 14.4236C9.41772 14.3275 9.35224 14.205 9.32571 14.0716C9.29918 13.9383 9.3128 13.8 9.36483 13.6744C9.41687 13.5488 9.50499 13.4414 9.61805 13.3659C9.7311 13.2903 9.86403 13.25 10 13.25C10.1823 13.25 10.3572 13.3224 10.4861 13.4514C10.6151 13.5803 10.6875 13.7552 10.6875 13.9375ZM14.125 13.9375C14.125 14.0735 14.0847 14.2064 14.0091 14.3195C13.9336 14.4325 13.8262 14.5206 13.7006 14.5727C13.575 14.6247 13.4367 14.6383 13.3034 14.6118C13.17 14.5853 13.0475 14.5198 12.9514 14.4236C12.8552 14.3275 12.7897 14.205 12.7632 14.0716C12.7367 13.9383 12.7503 13.8 12.8023 13.6744C12.8544 13.5488 12.9425 13.4414 13.0555 13.3659C13.1686 13.2903 13.3015 13.25 13.4375 13.25C13.6198 13.25 13.7947 13.3224 13.9236 13.4514C14.0526 13.5803 14.125 13.7552 14.125 13.9375Z"
                                    stroke-width="0.5" />
                            </g>
                        </svg>
                    </article>
                </div>

                <div>
                    <h5>Carga Horária</h5>
                    <article class="art-camp">
                        <input type="text" disabled [value]="bolsaInstCursoRenovar?.programaCargaHorario">
                    </article>
                </div>

                <div>
                    <h5>Estado da matrícula</h5>
                    <article class="select">
                        <select name="" id="" [(ngModel)]="estadoMatricula">
                            <option value="Selecione o estado">Selecione o estado</option>
                            @for (item of listaEstados; track $index) {
                            <option value="{{item.id}}">{{item.designacao}}</option>
                            }
                        </select>
                    </article>
                </div>

            </div>

            <article class="inst-learn mt-4">
                <h5>Instituição de ensino</h5>
                <span></span>
            </article>

            <div class="details-file mt-4">

                @for (item of listaAnexos; track $index) {
                <div class="file-up">
                    <label [for]="'file-upload-' + $index">
                        <i class="pi pi-cloud-upload"></i>
                        <article>
                            <strong>{{ item.descricao }}{{ item.required ? ' - *Obrigatório' : '' }}</strong>
                            <p *ngIf="item.file">{{ item.file.name }} - {{ item.file.size / 1024 | number:'1.0-2' }} KB
                            </p>
                            <p *ngIf="!item.file">Nenhum arquivo selecionado</p>
                        </article>
                        <input type="file" [id]="'file-upload-' + $index" accept=".pdf"
                            (change)="onFileSelected($event, item)">
                    </label>
                    <i class="pi pi-trash" (click)="removeFile(item)" *ngIf="item.file"></i>
                </div>
                }

            </div>

            <div class="btns-options mt-5">
                <button (click)="Return()">voltar</button>
                <button>Solicitar renovação</button>
            </div>
        </div>

    </div>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>
<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

    <form [formGroup]="form" class="p-fluid grid">
        <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
            <label>{{ filter.placeholder }}</label>

            <!-- Se for dropdown -->
            <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
                [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
                [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
            </p-select>

            <!-- Se for texto -->
            <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
                [placeholder]="filter.placeholder" class="w-full" />
        </div>
    </form>


    <div class="flex items-center justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
        <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
    </div>
</p-dialog>